export const gtmEvents = {
  EMAIL_SUBMITION: 'emailSubmission',
  ERROR_MESSAGE: 'errorMessage',
  BUTTON_CLICK: 'buttonClick',
  LINK_CLICK: 'linkClick',
};
